﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyHeroInfo", function () {
    var link = function ($scope, $element) {
      if ($element.next().is("[data-ty-fancy-accordion]")) {
        $element.addClass("vehicle-info--fancy-accordion");
      }
    };

    return {
      scope: false,
      restrict: "A",
      link: link,
    };
  });
})(window.angular);
